import { Box } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import Main from './Main';
import ApplicationForm from './components/externalPages/ApplicationForm';

function App() {
  return (
    <Box sx={{
      width: '100%', backgroundColor: '#002853', color: '#fff', padding: '20px 0',
    }}
    >
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route path="/apply_now" element={<ApplicationForm />} />
      </Routes>
    </Box>
  );
}

export default App;
